import { render, staticRenderFns } from "./ViewModalCfdisRelacionados.vue?vue&type=template&id=26979286&"
import script from "./ViewModalCfdisRelacionados.vue?vue&type=script&lang=js&"
export * from "./ViewModalCfdisRelacionados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports